import type { KataId } from '../catalog/types'
import { itsutsuNoKataScoring } from './itsutsu-no-kata'
import { juNoKataScoring } from './ju-no-kata'
import { katameNoKataScoring } from './katame-no-kata'
import { kimeNoKataScoring } from './kime-no-kata'
import { kodokanGoshinJutsuScoring } from './kodokan-goshin-jutsu'
import { koshikiNoKataScoring } from './koshiki-no-kata'
import { nageNoKataScoring } from './nage-no-kata'
import type { KataScoringDefinition } from './types'

export * from './types'
export { IJF_KATA_EVALUATION_SOURCE } from './source'
export { itsutsuNoKataScoring } from './itsutsu-no-kata'
export { juNoKataScoring } from './ju-no-kata'
export { katameNoKataScoring } from './katame-no-kata'
export { kimeNoKataScoring } from './kime-no-kata'
export { kodokanGoshinJutsuScoring } from './kodokan-goshin-jutsu'
export { koshikiNoKataScoring } from './koshiki-no-kata'
export { nageNoKataScoring }

const byId: Partial<Record<KataId, KataScoringDefinition>> = {
  'nage-no-kata': nageNoKataScoring,
  'katame-no-kata': katameNoKataScoring,
  'ju-no-kata': juNoKataScoring,
  'kime-no-kata': kimeNoKataScoring,
  'kodokan-goshin-jutsu': kodokanGoshinJutsuScoring,
  'koshiki-no-kata': koshikiNoKataScoring,
  'itsutsu-no-kata': itsutsuNoKataScoring,
}

export function getKataScoring(kataId: KataId): KataScoringDefinition | undefined {
  return byId[kataId]
}

export function isScoringSupported(kataId: KataId): boolean {
  return Boolean(byId[kataId])
}

export function listScorableKataIds(): KataId[] {
  return Object.keys(byId) as KataId[]
}
